const palette = {
  white: '#ffffff',
  white20: 'rgba(255, 255, 255, 0.2)',
  white40: 'rgba(255, 255, 255, 0.4)',
  green10: '#e7f6f3',  // 'rgba(23,166,137,0.1)'
  green20: '#d1ede7',  // 'rgba(23,166,137,0.2)'   
  green50: '#8bd3c4', //'rgba(23,166,137,0.5)',     ???? 
  green: '#17a689',
  grass: '#329c2e',
  grasslight: '#c0ecc7',   // flow condition background
  pink: '#f8e9ea',    // errors background  
  rosa: '#ff909e',
  red: '#e05465',     // errors colors
  yellowlight: '#fff5cd',
  yellow: '#fff888',
  sunglow: '#ffc729',
  tangerine: '#ee8d03',
  black10: 'rgba(0, 0, 0, 0.1)', // used for shadows mostly
  black20: 'rgba(0, 0, 0, 0.2)', // used for shadows mostly
  gray3: '#f6f6f6', // application bg
  gray5: '#f2f2f2',   //'rgba(0, 0, 0, 0.05)',
  gray10: '#e5e5e5',   //'rgba(0, 0, 0, 0.1)', 
  gray20: '#cccccc',   //'rgba(0, 0, 0, 0.2)',
  gray40: '#999999',   //'rgba(0, 0, 0, 0.4)',
  gray50: '#7f7f7f',    //'rgba(0, 0, 0, 0.50), used for default checkbox, radio button, icon color
  graphite: '#394146',   // main text
  black: '#000000',
  bluelight: '#edf5ff',   // ex. tracking urls info
  bluegray: '#58717f', // report footer text and border
  blue: '#267ae9',
  bluedark: '#314a77',
  bluedeep: '#1e3948',
  violet: '#ac35ff',   // ex. add new column formula
}

export { palette }

// helpful for color naming https://chir.ag/projects/name-that-color/
